import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

class HorizontalTextScroller {

	static instance = null;

	static create(options) {
		if (!HorizontalTextScroller.instance) {
			HorizontalTextScroller.instance = new HorizontalTextScroller(options);
		}
		return HorizontalTextScroller.instance;
	}

	static destroy() {
		if (HorizontalTextScroller.instance) {
			HorizontalTextScroller.instance.beforeDestroy();
			HorizontalTextScroller.instance = null;
		}
	}

	static getDefaultOptions() {
		return {
			container: null,
			selector: null,
		}
	}

	constructor(options) {
		this.options = Object.assign({}, HorizontalTextScroller.defaultOptions, options);
		this.init();
	}

	init() {
		this.initScrollAnimations();
	}

	initScrollAnimations() {
		if (this.options.selector.length > 0) {
			this.horizontalTl = this.options.selector.map(line => {
				const lineItems = line.querySelectorAll('span');
				let tl = gsap.timeline({
					scrollTrigger: {
						trigger: line,
						start: "top bottom",
						end: "bottom top",
						scrub: true,
						scroller: "[data-scroll-container]",
						markers: false
					},
				});
		
				for (let i = 0; i < lineItems.length; i++) {
					const moveDirection = i % 2 === 0 ? `+=${window.innerWidth / 3}` : `-=${window.innerWidth / 3}`;
					tl.to(lineItems[i], {
						x: moveDirection,
						ease: 'power1.out',
					}, 0);
				}
		
				return tl;
			});
		}
	}

	beforeDestroy() {
		if (this.horizontalTl !== null) {
			ScrollTrigger.getAll().forEach(tl => {
				tl.kill();
			})

			this.horizontalTl = null;
		}

	}
}

export default HorizontalTextScroller;